import { BACKEND_API_URL } from "../Config";
import { fetchWithAuth, handleApiResponse } from "../Utils";

export const fetchProductionCosts = async ({ onSuccess, onError }) => {
  try {
    const response = await fetch(
      `${BACKEND_API_URL}/production-cost`,
      { method: "GET" },
    );

    const data = await handleApiResponse(response, "fetchProductionCosts");

    if (onSuccess) onSuccess(data);
    return data;
  } 
  catch (error) {
    if (onError) {
      onError(error);
      return;
    }
    throw error;
  }
};
